export default __webpack_public_path__ + "static/media/firefox.71d9f8ec.png";